// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3tr4p";
var _3 = "details-UQsVh";
var _4 = "item-1gMJO";
var _5 = "totalRefund-3woHO";
export { _1 as "__esModule", _2 as "root", _3 as "details", _4 as "item", _5 as "totalRefund" }
export default { "__esModule": _1, "root": _2, "details": _3, "item": _4, "totalRefund": _5 }
